import setErrorDataArray from './setErrorDataArray';

const sagaSetErrorHelperFn = error => {
	const { data } = error.response;

	return setErrorDataArray(data);
};

export default sagaSetErrorHelperFn;
